import React from 'react';

export default function FrontEngineDoubleIcon() {
  return (
   <svg fill="none" viewBox="0 0 70 42" xmlns="http://www.w3.org/2000/svg">
    <path d="M69.1224 35.0758C60.2968 13.8392 39.5588 0 16.5613 0H0.883653C0.395626 0 0 0.395624 0 0.883651V40C0 41.1046 0.895431 42 2 42H64.5016C68.0703 42 70.4919 38.3712 69.1224 35.0758ZM21 16H42.3668C44.2498 16 45.0894 13.6352 43.628 12.4478L40.0301 9.52448C40.01 9.50816 39.9929 9.49465 39.9721 9.47933C39.5241 9.15012 33.762 5 28 5H21C19.8954 5 19 5.89543 19 7V14C19 15.1046 19.8954 16 21 16ZM5 5C3.89543 5 3 5.89543 3 7V14C3 15.1046 3.89543 16 5 16H15C16.1046 16 17 15.1046 17 14V7C17 5.89543 16.1046 5 15 5H5Z" clipRule="evenodd" fill="#194245" fillRule="evenodd" />
   </svg>
  );
}
